module.exports = __webpack_public_path__ + "static/media/alex.1ba011c2.jpg";